export function initFooterDrilldown() {
  const mql = window.matchMedia('(max-width: 1080px)');
  const groups = document.querySelectorAll('.site-footer__nav-group');
  if (!groups.length) return;

  function getPanel(btn) {
    const panel = btn.nextElementSibling;
    return panel && panel.classList.contains('site-footer__panel') ? panel : null;
  }

  function applyState() {
    const isMobile = mql.matches;
    groups.forEach((group) => {
      const btn = group.querySelector('.site-footer__nav-toggle');
      const panel = btn && getPanel(btn);
      if (!btn || !panel) return;

      if (isMobile) {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  }

  function onToggle(e) {
    const btn = e.currentTarget;
    const panel = getPanel(btn);
    if (!panel) return;
    if (!mql.matches) return;             // Desktop: ignorieren (immer offen)

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    panel.setAttribute('aria-hidden', expanded ? 'true' : 'false');
  }

  groups.forEach((group) => {
    const btn = group.querySelector('.site-footer__nav-toggle');
    if (btn) btn.addEventListener('click', onToggle);
  });

  applyState();
  mql.addEventListener('change', applyState);
}